import { ClosepaymentModalOptionsInterface } from 'types/close-payment';
import { DropdownOption } from 'types/dropdown';
import { TabPill } from 'types/tabs';
import {
  MarkAsPaidOptionsInterface,
  UpdateDueOptionsInterface
} from 'types/transaction';

export const transactionsTabs: TabPill[] = [
  { id: 1, label: 'Recent' },
  { id: 2, label: 'Paid' },
  { id: 3, label: 'Pending' },
  { id: 4, label: 'Partially Paid' }
];

export const transactionTabFilterOptions = [
  { id: 1, label: 'All Payments', value: 'all' },
  { id: 2, label: 'Group Payments', value: 'group' },
  { id: 3, label: 'Quick Collect', value: 'individual' }
];

export const allTransactionsTabTableColumn = (hideMobileNumber: boolean) => [
  { Header: 'Name', accessor: 'name', width: '20%' },
  ...(!hideMobileNumber
    ? [
        {
          Header: 'Mobile Number',
          accessor: 'phoneNumber',
          width: '20%'
        }
      ]
    : []),
  { Header: 'Requested on', accessor: 'dueFrom', width: '18%' },
  { Header: 'Paid On', accessor: 'paidOn', width: '15%' },
  { Header: 'Settled On', accessor: 'settledOn', width: '20%' },
  { Header: 'Amount', accessor: 'amount', width: '15%' },
  { Header: 'Actions', accessor: 'actions' }
];

export const paidTransactionsTabTableColumn = (hideMobileNumber: boolean) => [
  { Header: 'Name', accessor: 'name', width: '20%' },
  ...(!hideMobileNumber
    ? [
        {
          Header: 'Mobile Number',
          accessor: 'phoneNumber',
          width: '20%'
        }
      ]
    : []),
  { Header: 'Requested on', accessor: 'dueFrom', width: '18%' },
  { Header: 'Paid On', accessor: 'paidOn', width: '18%' },
  { Header: 'Settled On', accessor: 'settledOn', width: '20%' },
  { Header: 'Amount', accessor: 'amount', width: '15%' },
  { Header: 'Actions', accessor: 'actions' }
];

export const pendingTransactionsTabTableColumn = (
  hideMobileNumber: boolean
) => [
  { Header: 'Name', accessor: 'name', width: '30%' },
  ...(!hideMobileNumber
    ? [
        {
          Header: 'Mobile Number',
          accessor: 'phoneNumber',
          width: '20%'
        }
      ]
    : []),
  { Header: 'Requested on', accessor: 'dueFrom', width: '25%' },
  { Header: 'Amount', accessor: 'amount', width: '25%' },
  { Header: 'Actions', accessor: 'actions' }
];

export const memberAllTransactionTableColumn = () => [
  { Header: 'Group/Notes', accessor: 'group', width: '20%' },
  { Header: 'Requested on', accessor: 'dueFrom', width: '18%' },
  { Header: 'Paid On', accessor: 'paidOn', width: '18%' },
  { Header: 'Settled On', accessor: 'settledOn', width: '20%' },
  { Header: 'Amount', accessor: 'amount', width: '15%' },
  { Header: 'Actions', accessor: 'actions', width: '9%' }
];

export const memberPendingTransactionTableColumn = () => [
  { Header: 'Group/Notes', accessor: 'group', width: '40%' },
  { Header: 'Requested on', accessor: 'dueFrom', width: '25%' },
  { Header: 'Amount', accessor: 'amount', width: '25%' },
  { Header: 'Actions', accessor: 'actions', width: '10%' }
];

export const memberTransactionInitialState = {
  id: '',
  name: '',
  note: '',
  amount: '0',
  status: '',
  remind_again: false,
  paid_at: null,
  due_at: '',
  payment_link: '',
  type: '',
  order_short_url: '',
  receipt_url: '',
  settled_at: '',
  settlement_status: '',
  payment_mode: '',
  is_split_payment: false,
  total_settled_amount: '',
  total_paid_amount: '',
  payment_description: '',
  payment_method: '',
  disabled_at: null,
  disabled_reason: null,
  payment_to: '',
  total_amount: '0'
};

export enum TransactionHistoryDescription {
  payment_mode = 'Paid',
  transaction_id = 'Transaction ID',
  paid_at = 'Paid on',
  payment_description = 'Notes',
  settled_at = 'Settled On',
  utr = 'UTR Number',
  marked_paid_at = 'Marked On'
}

export const preDefinedKey = {
  paymentMode: 'payment_mode', // Paid
  transactionId: 'transaction_id', // Transaction ID
  paidAt: 'paid_at', // Paid on
  paymentDescription: 'payment_description', // Notes
  utr: 'utr',
  settledAt: 'settled_at', // Settled On
  markedPaidAt: 'marked_paid_at' // Marked Paid On
};

export const markAsPaidOptionsInitialState: MarkAsPaidOptionsInterface = {
  id: '',
  amount: '',
  name: '',
  is_split_payment: false,
  paid_amount: ''
};

export const updateDueOptionsInitialState: UpdateDueOptionsInterface = {
  id: '',
  total_fee: '',
  total_paid: '',
  name: '',
  action: 'none'
};

// eslint-disable-next-line max-len
export const ClosepaymentModalOptionsInitialState: ClosepaymentModalOptionsInterface =
  {
    total_amount: '',
    total_paid_amount: ''
  };

export enum AmountMode {
  CASH = 'Cash',
  BANK = 'Bank Transfer',
  UPI = 'UPI Transfer',
  CHEQUE = 'Cheque'
}

export enum AmountType {
  FULL = 'full',
  PARTIAL = 'partial'
}

export const amountTypeOptions = [
  { value: AmountType.FULL, label: 'Full Amount' },
  { value: AmountType.PARTIAL, label: 'Enter Amount' }
];

export const amountModeOptions = [
  { value: AmountMode.CASH, label: 'Cash' },
  { value: AmountMode.BANK, label: 'Bank Transfer' },
  { value: AmountMode.UPI, label: 'UPI Transfer' },
  { value: AmountMode.CHEQUE, label: 'Cheque' }
];

export enum TransactionModalContext {
  DISABLE_PAYMENT = 'Disable Payment',
  SEND_REMINDER = 'Send Reminder',
  ENABLE_PARTIAL_PAYMENT = 'Enable partial payment'
}

export enum TransactionStatus {
  DISABLED = 'Disabled',
  TO_SETTLE = 'To Settle',
  SETTLED = 'Settled',
  PROCCESSING = 'Processing',
  DEFAULT = 'Default'
}

export const transactionSearchCategories: DropdownOption[] = [
  {
    id: 'name',
    value: 'customerName',
    label: 'Customer Name'
  },
  {
    id: 'memberId',
    value: 'memberId',
    label: 'Member ID'
  },
  {
    id: 'orderId',
    value: 'merchantOrderId',
    label: 'Merchant Order ID'
  },
  {
    id: 'transactionId',
    value: 'transactionId',
    label: 'Transaction ID'
  },
  {
    id: 'mobile',
    value: 'mobileNumber',
    label: 'Mobile Number'
  }
];

const dateRangeOptions = [
  { id: 'current', label: 'Current Month', value: 'current' },
  { id: 'last', label: 'Last Month', value: 'last' },
  {
    id: 'current_year',
    label: 'Current Financial Year',
    value: 'current_year'
  },
  { id: 'last_year', label: 'Last Financial Year', value: 'last_year' },
  { id: 'custom', label: 'Custom Date Range', value: 'custom', type: 'date' }
];

// all, group, quickCollect
const paymentOptions = [
  { id: 'all', label: 'All Payments', value: 'all' },
  { id: 'group', label: 'Group Payments', value: 'group' },
  { id: 'quickCollect', label: 'Quick Collect', value: 'individual' }
];

export const filterOptions = {
  dateRange: {
    id: 1,
    label: 'Date Range',
    field: 'dateRange',
    options: dateRangeOptions
  },
  paymentType: {
    id: 2,
    label: 'Payments',
    field: 'paymentType',
    options: paymentOptions
  }
};

export const filterDefaultValues = {
  dateRange: [''],
  paymentType: [paymentOptions[0].value]
};
